import type { SiteConfig } from '../../@types/context/site-config.types';
import { serviceTrustpilotAxoConfig } from './service-trustpilot-axo.config';

export const serviceTrustpilotLendmeDkConfig: SiteConfig['services']['trustpilot'] =
  {
    ...serviceTrustpilotAxoConfig,
    businessUnitId: '577008a20000ff0005919d8a',
  };
